import React, { useState, useEffect, useRef, useContext } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { green } from "@material-ui/core/colors";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Typography from "@material-ui/core/Typography";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Radio from "@material-ui/core/Radio";
import { Grid, Stack } from "@mui/material";
import { toast } from "react-toastify";
import { i18n } from "../../translate/i18n";
import api from "../../services/api";
import { AuthContext } from "../../context/Auth/AuthContext";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexWrap: "wrap",
  },
  btnWrapper: {
    position: "relative",
  },
  buttonProgress: {
    color: green[500],
    position: "absolute",
    top: "50%",
    left: "50%",
    marginTop: -12,
    marginLeft: -12,
  },
}));

const FlowBuilderCampaignProModal = ({ open, onSave, data, onUpdate, close }) => {
  const classes = useStyles();
  const isMounted = useRef(true);
  const { user } = useContext(AuthContext);

  const [activeModal, setActiveModal] = useState(false);
  const [lists, setLists] = useState([]);
  const [selectedListId, setSelectedListId] = useState("");
  const [action, setAction] = useState("add"); // "add" | "remove"

  useEffect(() => {
    if (open === "edit" || open === "create") {
      (async () => {
        try {
          const { data: listData } = await api.get("/contact-lists-pro/list", {
            params: { companyId: user?.companyId },
          });
          setLists(Array.isArray(listData) ? listData : []);

          if (open === "edit" && data?.data) {
            setAction(data.data.action || "add");
            setSelectedListId(data.data.list?.id ?? "");
          } else {
            setAction("add");
            setSelectedListId("");
          }
          setActiveModal(true);
        } catch (err) {
          console.error(err);
          toast.error("Erro ao carregar listas da Campanha PRO");
        }
      })();
    }
    return () => {
      isMounted.current = false;
    };
  }, [open, user?.companyId]);

  const handleClose = () => {
    close(null);
    setActiveModal(false);
  };

  const handleSave = () => {
    if (!selectedListId) {
      return toast.error("Selecione uma lista da Campanha PRO");
    }
    const list = lists.find((l) => l.id === selectedListId);
    if (!list) {
      return toast.error("Lista inválida");
    }

    const payload = {
      action,
      list: { id: list.id, name: list.name },
    };

    if (open === "edit") {
      onUpdate({
        ...data,
        data: payload,
      });
    } else {
      onSave(payload);
    }
    handleClose();
  };

  return (
    <div className={classes.root}>
      <Dialog
        open={activeModal}
        onClose={handleClose}
        maxWidth="sm"
        fullWidth
        scroll="paper"
      >
        <DialogTitle id="campaign-pro-dialog-title">
          {open === "create" ? "Configurar bloco Campanha PRO" : "Editar bloco Campanha PRO"}
        </DialogTitle>
        <Stack>
          <DialogContent dividers>
            <Grid container spacing={2} style={{ width: "100%", marginTop: 8 }}>
              <Grid item xs={12}>
                <Typography style={{ marginBottom: 10 }}>
                  Ação ao executar este bloco
                </Typography>
                <FormControl component="fieldset">
                  <RadioGroup
                    row
                    value={action}
                    onChange={(e) => setAction(e.target.value)}
                  >
                    <FormControlLabel value="add" control={<Radio />} label="Adicionar contato na lista" />
                    <FormControlLabel value="remove" control={<Radio />} label="Remover contato da lista" />
                  </RadioGroup>
                </FormControl>
              </Grid>
              <Grid item xs={12}>
                <Typography style={{ marginBottom: 8 }}>
                  Lista da Campanha PRO
                </Typography>
                <FormControl fullWidth variant="outlined" size="small">
                  <InputLabel id="campaign-pro-list-label">Lista</InputLabel>
                  <Select
                    labelId="campaign-pro-list-label"
                    value={selectedListId}
                    onChange={(e) => setSelectedListId(e.target.value)}
                    label="Lista"
                    renderValue={(v) => {
                      const l = lists.find((x) => x.id === v);
                      return l ? l.name : "Selecione uma lista";
                    }}
                  >
                    <MenuItem value="">
                      <em>Selecione uma lista</em>
                    </MenuItem>
                    {lists.map((list) => (
                      <MenuItem key={list.id} value={list.id}>
                        {list.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                <Typography variant="caption" color="textSecondary" style={{ marginTop: 8, display: "block" }}>
                  Quando o fluxo passar por este bloco, o contato do atendimento será {action === "add" ? "adicionado à" : "removido da"} lista selecionada.
                </Typography>
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} color="secondary" variant="outlined">
              {i18n.t("contactModal.buttons.cancel")}
            </Button>
            <Button
              type="button"
              color="primary"
              variant="contained"
              className={classes.btnWrapper}
              onClick={handleSave}
            >
              {open === "create" ? "Adicionar bloco" : "Salvar"}
            </Button>
          </DialogActions>
        </Stack>
      </Dialog>
    </div>
  );
};

export default FlowBuilderCampaignProModal;
